<template>
  <div id="creator_user_commission">
    <van-nav-bar placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="22" offset="1" class="creator_user_commission_bg">
        <van-col span="24" class="creator_user_commission_bg_top">
          <van-col span="10" offset="1" class="creator_user_commission_bg_top_left">
            <img src="../assets/img/creator_user_commission_task.png"/>
            Creator Task
          </van-col>
          <van-col span="12" class="creator_user_commission_bg_top_right">
            <van-icon name="clock-o" size="15" color="#FF61F5"/> <van-count-down :time="time" class="creator_user_commission_bg_top_right_down" />
          </van-col>
        </van-col>
        <van-col span="22" offset="1" class="creator_user_commission_title"> {{ $t('column.daily_active_task') }}</van-col>
        <van-col span="22" offset="1" class="creator_user_commission_k_bg">
          <van-col span="22" offset="1" class="creator_user_commission_time"> {{ progress_date }} </van-col>
          <van-col span="22" offset="1" class="creator_user_commission_date">
            <van-col span="12">
              <van-col span="24" class="creator_user_commission_date_title"> {{ $t('column.last_7_days_earnings') }}</van-col>
              <van-col span="24" class="creator_user_commission_date_sum">
                <img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/> {{ progress_income }}
              </van-col>
            </van-col>
            <van-col span="12">
              <van-col span="24" class="creator_user_commission_date_title"> {{ $t('column.hourly_rewards') }} </van-col>
              <van-col span="24" class="creator_user_commission_date_sum">
                <img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/> {{ progress_reward }} / {{ progress_hour }} h
              </van-col>
            </van-col>
          </van-col>
          <van-col span="22" offset="1">
            <div class="scrollable-container">
              <div class="creator_user_commission_progress">
                <van-progress :percentage="progress_sum" :style="{'margin-left':progress_width_left,'width':progress_width_val}" color="#F5E7FF" track-color="#ffffff" stroke-width="10" :show-pivot="false"/>
                <van-col span="24" class="creator_user_commission_progress_text">
                  <div class="progress-items-container">
                    <div v-for="(item,i) in progress_list" :key="i" :style="{'width':progress_width}" class="creator_user_commission_progress_text_line">
                      <div class="creator_user_commission_progress_text_top">
                        <div class="creator_user_commission_progress_text_top_name">{{ item.income | numberFormat }}</div>
                        <div class="creator_user_commission_progress_text_top_img"><img src="../assets/img/coin9.png" class="creator_agency_commission_coin"/></div>
                      </div>
                      <div class="creator_user_commission_progress_text_centent" :style="{'padding-left':'50%'}">
                        <div class="creator_user_commission_progress_text_centent_bg"></div>
                      </div>
                      <div class="creator_user_commission_progress_text_bottom">{{ item.reward_income | numberFormat }}/h</div>
                    </div>
                  </div>
                </van-col>
              </div>
            </div>
          </van-col>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"

export default {
  filters: {
    numberFormat(value) {
      const num = typeof value === 'string' ? parseFloat(value) : value
      return num.toLocaleString()
    }
  },
  data() {
    return {
      progress_date : '',
      progress_width: '0%',
      progress_width_val: '100%',
      progress_width_left:0,
      progress_sum: 0,
      progress_list: [],
      progress_income: undefined,
      progress_hour: undefined,
      progress_reward: undefined,
      time: 0
    }
  },
  created() {
    const now = new Date();
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
    // 计算剩余时间（毫秒）
    this.time = endOfDay - now;
    this.getList()
  },
  methods: {
    getList(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_user_commission",{
        params:{uid: uid, token: token}
      }).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.progress_date = res.data.data.progress_date
          this.progress_list = res.data.data.progress_list
          this.progress_sum = res.data.data.progress_sum

          this.progress_income = res.data.data.progress_income
          this.progress_hour = res.data.data.progress_hour
          this.progress_reward = res.data.data.progress_reward
          this.markPosition()
        }else{
          Toast(res.data.error)
        }
      })
    },
    markPosition() {
      const index = this.progress_list.length
      // 计算每个进度项的宽度（总宽度的1/4）
      this.progress_width = (100 / 4) + '%'
      // 计算左边距，使进度条居中显示
      this.progress_width_left = (100 / 4) / 2 + '%'
      // 计算进度条总宽度：(每个项目宽度 - 1%) * 项目数量 - 适当的右边距
      // 减去1%是为了在项目之间留出一些间隔
      // 再减去(100/4)/2%使得最右边不会延伸到容器边缘，而是停在最后一个紫色圆点位置
      this.progress_width_val = ((100 / 4 - 1) * index - (100 / 4) / 2) + '%'

    },
    onClickLeft() {
      // 拦截关闭h5
      this.$router.go(-1)
    }
  }
}
</script>
<style>
.scrollable-container {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  min-height: 25vw;
}

.creator_user_commission_progress {
  width: 100%;
}

/* 进度项容器 - 水平排列并允许超出父容器 */
.progress-items-container {
  display: flex;
  min-width: max-content;
}

/* 每个进度项的样式 */
.creator_user_commission_progress_text_line {
  flex-shrink: 0;
}

/* 隐藏滚动条但保留滚动功能 */
.scrollable-container::-webkit-scrollbar {
  height: 0;
}

.scrollable-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* 为移动端添加滚动行为平滑 */
.scrollable-container {
  scroll-behavior: smooth;
}
</style>



// WEBPACK FOOTER //
// src/components/creator_user_commission.vue